<template>
    <span>
        <div class="autocomplete"
             :class="{ 'full-width': fullWidth }">
            <input v-model="search"
                   @input="onSearchChange"
                   @keyup.up="onSearchArrowUp"
                   @keyup.down="onSearchArrowDown"
                   @keyup.enter="onSearchEnter"
                   @keyup.esc="$emit('hide-search')"
                   autofocus="autofocus"
                   type="text"
                   autocomplete="off"
                   minlength="3"
                   maxlength="64"
                   required="required"
                   pattern=".{1,}"
                   title="Podaj nazwę lub kod produktu"
                   ref="search"
                   placeholder="Czego szukasz?" />
            <ul id="autocomplete-results" v-show="isAutocompleteOpen" class="autocomplete-results">
                <li class="autocomplete-result" v-if="isAutocompleteLoading">
                    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                </li>
                <li v-else v-for="(result, i) in results"
                    :key="i"
                    @click.prevent="setResult(result)"
                    class="autocomplete-result"
                    :class="{ 'is-active': i === arrowCounter }">
                    {{ result.value }}
                </li>
            </ul>
        </div>
        <button type="submit"
                @click.prevent="$emit('search',search)"
                class="mobile-magnifier-button"><img src="images/magnifier.svg" width="16" height="16" alt="Szukaj" /></button>
    </span>
</template>

<script>
    import axios from 'axios';
    import lodash from 'lodash';

    export default {
        name: "Autocomplete",
        props: {
            fullWidth: Boolean,
        },
        data() {
            return {
                results: [],
                isAutocompleteLoading: false,
                isAutocompleteOpen: false,
                arrowCounter: 0,
                search: SEARCH_TEXT,
            }
        },
        methods: {
            searchResultsAction: lodash.debounce(async function() {
                this.$emit("input", this.search);
                this.isAutocompleteLoading = true;
                this.isAutocompleteOpen = true;

                try {
                    const response = await axios.get(`autosuggest.ajax.json.php?q=${this.search}&limit=20`);

                    this.results = response.data;
                } catch (error) {
                    toast.error('Wystąpił błąd podczas wyszukiwania');
                }

                this.isAutocompleteLoading = false;
            }, 500),

            onSearchChange() {
                if (this.search.length>=3) {
                    this.searchResultsAction();
                }
            },

            setResult(result) {
                this.search = result.value
                this.isAutocompleteOpen = false
                this.$emit('search',this.search)
            },
            onSearchArrowDown() {
                if (this.arrowCounter < this.results.length) {
                    this.arrowCounter = this.arrowCounter + 1
                }
            },
            onSearchArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter - 1
                }
            },
            onSearchEnter() {
                if ( this.arrowCounter >= 0) {
                    this.search = this.results[this.arrowCounter].value
                }
                this.isAutocompleteOpen = false
                this.arrowCounter = -1
                this.$emit('search',this.search)
            },
            handleClickOutside(evt) {
                if (!this.$el.contains(evt.target)) {
                    this.isAutocompleteOpen = false
                    this.isAutocompleteLoading = false
                    this.arrowCounter = -1
                }
            }
        },
        mounted() {
            document.addEventListener("click", this.handleClickOutside)
            this.$refs.search.focus()
            this.$refs.search.oninvalid = this.$refs.search.setCustomValidity('Podaj nazwę lub kod produktu');
        },
        destroyed() {
            document.removeEventListener("click", this.handleClickOutside)
        },
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/variables";
    @import "../../../../../scss/mixins/breakpoint";

    .mobile-magnifier-button {
        display: -webkit-flex;
        display: flex;
        align-items: center;
        -webkit-align-items: center;
        justify-content: center;
        -webkit-justify-content: center;
        text-align: center;
        float: left;
        width: 47px;
        height: 75px;
        padding: 0;
        background: #eeeeee;
        border: 0 none;
        cursor: pointer;

        &:hover {
            background-color: #eeeeee;
        }

        @include only-mobile-breakpoint() {
            height: $mobileHeaderHeight;
        }
    }

    .autocomplete {
        position: relative;
        margin: 0;
        border: 0 none;
        background: #eeeeee;
        color: #333333;
        padding: 12px 20px;
        cursor: pointer;
        width: calc(50% - 47px);
        float: left;

        &.full-width {
            width: calc(100% - 107px);
        }

        @include only-mobile-breakpoint() {
            height: 52px;
            padding-top: 4px;
            padding-bottom: 6px;
        }

        & input {
            border: 0 none;
            background-color: transparent;
            font-size: 18px;
            width: 100%;
            padding: 15px 0;

            @include only-mobile-breakpoint() {
                font-size: 13px;
            }

            &:invalid {
                box-shadow: none;
            }
        }

        & input:focus,
        & textarea:focus,
        & select:focus {
            outline: none;
        }
    }
    .autocomplete-results {
        position: absolute;
        padding: 0 20px 20px 18px;
        margin: 0 0 0 -20px;
        border: 1px solid #eeeeee;
        height: auto;
        overflow: auto;
        width: 100%;
        background-color: #eeeeee;
        z-index: 98;
        font-size: 14px;
    }
    .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;

        &.is-active {
            font-weight: bold;
            color: #345463;
        }
        &:hover {
            color: #345463;
            font-weight: bold;
            text-decoration: underline;
        }
    }
    @media (max-width: 640px) {
        .autocomplete {
            padding-right: 0;
        }
        .autocomplete-results {
            min-width: 300px;
        }
    }

    .lds-ring {
        display: inline-block;
        position: relative;
        width: 32px;
        height: 32px;

        & div {
            box-sizing: border-box;
            display: block;
            position: absolute;
            width: 26px;
            height: 26px;
            margin: 0;
            border-width: 4px;
            border-style: solid;
            border-radius: 50%;
            animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
            border-color: #ccc transparent transparent transparent;
        }
        & div:nth-child(1) {
            animation-delay: -0.45s;
        }
        & div:nth-child(2) {
            animation-delay: -0.3s;
        }
        & div:nth-child(3) {
            animation-delay: -0.15s;
        }
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
